import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * @graph-node {Page}
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business 旧URL。案件詳細ページの要件定義タブ（/projects/$pjKey/spec）へリダイレクトする
 * @graph-connects none
 */
export const Route = createFileRoute('/projects/spec/$pjKey/')({
  beforeLoad: ({ params }): never => {
    throw redirect({
      to: '/projects/$pjKey/spec',
      params: { pjKey: params.pjKey },
    }) as unknown as Error;
  },
  component: () => null,
});
